export const DEFAULT_CATALOG = 'magicwindow'
export const DEFAULT_SHOWROOM = 'default'
export const DEV_IDS_BY_REGION = {
    'us/en': {
        [DEFAULT_SHOWROOM]: {
            sceneId: '43416',
            compId: '10699',
            subCatalog: 'mw_living_st',
        },
        mwDiningPm: {
            sceneId: '44679',
            compId: '11148',
            subCatalog: 'mw_dining_pm',
        },
        mwDiningPt: {
            sceneId: '44681',
            compId: '11149',
            subCatalog: 'mw_dining_pt',
        },
        mwDiningSm: {
            sceneId: '44677',
            compId: '11147',
            subCatalog: 'mw_dining_sm',
        },
        mwDiningSt: {
            sceneId: '44674',
            compId: '11146',
            subCatalog: 'mw_dining_st',
        },
    },
    'nl/nl': {
        [DEFAULT_SHOWROOM]: {
            sceneId: '41440',
            compId: '10647',
            subCatalog: DEFAULT_CATALOG,
        },
        mwDiningPm: {
            sceneId: '44679',
            compId: '11340',
            subCatalog: 'mw_dining_pm',
        },
        mwDiningPt: {
            sceneId: '44681',
            compId: '11149',
            subCatalog: 'mw_dining_pt',
        },
        mwDiningSm: {
            sceneId: '44677',
            compId: '11768',
            subCatalog: 'mw_dining_sm',
        },
        mwDiningSt: {
            sceneId: '44674',
            compId: '12200',
            subCatalog: 'mw_dining_st',
        },
    },
    'nl/en': {
        [DEFAULT_SHOWROOM]: {
            sceneId: '41440',
            compId: '10647',
            subCatalog: DEFAULT_CATALOG,
        },
        mwDiningPm: {
            sceneId: '44679',
            compId: '11340',
            subCatalog: 'mw_dining_pm',
        },
        mwDiningPt: {
            sceneId: '44681',
            compId: '11149',
            subCatalog: 'mw_dining_pt',
        },
        mwDiningSm: {
            sceneId: '44677',
            compId: '11768',
            subCatalog: 'mw_dining_sm',
        },
        mwDiningSt: {
            sceneId: '44674',
            compId: '12200',
            subCatalog: 'mw_dining_st',
        },
    },
    'gb/en': {
        [DEFAULT_SHOWROOM]: {
            sceneId: '41322',
            compId: '10647',
            subCatalog: DEFAULT_CATALOG,
        },
    },
}
export const PROD_IDS_BY_REGION = {
    'us/en': {
        [DEFAULT_SHOWROOM]: {
            sceneId: '25810',
            compId: '11426',
            subCatalog: 'mw_living_st',
        },
        mwDiningPm: {
            sceneId: '25816',
            compId: '11397',
            subCatalog: 'mw_dining_pm',
        },
        mwDiningPt: {
            sceneId: '25818',
            compId: '11389',
            subCatalog: 'mw_dining_pt',
        },
        mwDiningSm: {
            sceneId: '25814',
            compId: '11400',
            subCatalog: 'mw_dining_sm',
        },
        mwDiningSt: {
            sceneId: '25812',
            compId: '11399',
            subCatalog: 'mw_dining_st',
        },
    },
    'nl/nl': {
        [DEFAULT_SHOWROOM]: {
            sceneId: '21127',
            compId: '10824',
            subCatalog: DEFAULT_CATALOG,
        },
        mwDiningPm: {
            sceneId: '25816',
            compId: '12540',
            subCatalog: 'mw_dining_pm',
        },
        mwDiningSt: {
            sceneId: '27838',
            compId: '11946',
            subCatalog: 'mw_dining_st',
        },
        mwDiningSm: {
            sceneId: '27837',
            compId: '11945',
            subCatalog: 'mw_dining_sm',
        },
        mwDiningPt: {
            sceneId: '25818',
            compId: '11933',
            subCatalog: 'mw_dining_pt',
        },
    },
    'nl/en': {
        [DEFAULT_SHOWROOM]: {
            sceneId: '21127',
            compId: '10824',
            subCatalog: DEFAULT_CATALOG,
        },
        mwDiningPm: {
            sceneId: '27839',
            compId: '11947',
            subCatalog: 'mw_dining_pm',
        },
        mwDiningSt: {
            sceneId: '27838',
            compId: '11946',
            subCatalog: 'mw_dining_st',
        },
        mwDiningSm: {
            sceneId: '27837',
            compId: '11945',
            subCatalog: 'mw_dining_sm',
        },
        mwDiningPt: {
            sceneId: '25818',
            compId: '11933',
            subCatalog: 'mw_dining_pt',
        },
    },
    'gb/en': {
        [DEFAULT_SHOWROOM]: {
            sceneId: '21127',
            compId: '10825',
            subCatalog: DEFAULT_CATALOG,
        },
    },
}
